export default [
  'Should have used a compiled language...',
  'Don\'t break your screen yet...',
  'I swear it\'s almost done...',
  'Where did all the internets go...',
  'Time flies when you’re having fun...',
  'Your left thumb points to the right and your right thumb points to the left...',
  'I’ve got problem for your solution...',
  'Grabbing extra minions...',
  'Dividing by zero...',
  'Ordering 1s and 0s...',
];
